// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__1IpMY","White":"Link_White__2UTkj Link_Link__1IpMY","Red":"Link_Red__170-7 Link_Link__1IpMY"};